import { LoadingButton } from "@mui/lab";
import { Checkbox, Link, Stack, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { TERMS } from "../../../../enums/UrlPaths";

export default function RegSubmit({ isLoading = false }) {
  const [isChecked, setIsChecked] = React.useState(false);
  const { t } = useTranslation();

  const handleCheckbox = () => {
    setIsChecked((prev) => !prev);
  };

  return (
    <Stack spacing={3} mt={4} width="100%">
      <Stack direction="row" alignItems="center" spacing={2}>
        <Checkbox
          onChange={handleCheckbox}
          checked={isChecked}
          sx={{
            color: isChecked ? "primary.main" : "text.secondary",
            "& .MuiSvgIcon-root": {
              fontSize: 28, // Adjust the size of the checkbox
            },
          }}
          inputProps={{ "data-testid": "auth.signup.terms-checkbox" }}
        />

        <Typography variant="body2">
          {t("OnClickOfButtonAccept")}{" "}
          <Link
            href={TERMS}
            underline="hover"
            style={{ color: "primary", cursor: "pointer", display: "inline" }}
          >
            {t("TermsAndConditions")}
          </Link>{" "}
          {t("OfZookeeperApp")}
        </Typography>
      </Stack>

      <LoadingButton
        fullWidth
        variant="contained"
        type="submit"
        disabled={!isChecked}
        loading={isLoading}
        sx={{
          backgroundColor: !isChecked ? "grey.400" : "primary.main",
          "&:hover": {
            backgroundColor: !isChecked ? "grey.400" : "primary.dark",
          },
        }}
        data-testid="auth.signup.submit-button"
      >
        {t("SignUp")}
      </LoadingButton>
    </Stack>
  );
}
